<template>
  <w-icon-wrapper icon-name='work-customer-icon'>
    <path
      id='_64_Beim_Kunden_Icon'
      d='M23.27,17.82a12.05,12.05,0,0,0-7.208-6.17A6.43,6.43,0,0,0,18.684,6.5,6.607,6.607,0,0,0,12,0,6.607,6.607,0,0,0,5.316,6.5a6.43,6.43,0,0,0,2.622,5.15A12.05,12.05,0,0,0,.73,17.82,10.6,10.6,0,0,0,0,19.84a18.024,18.024,0,0,0,1.83,1.28,19.4,19.4,0,0,0,20.34,0A18.024,18.024,0,0,0,24,19.84,10.6,10.6,0,0,0,23.27,17.82ZM7.373,6.5a4.629,4.629,0,0,1,9.254,0,4.629,4.629,0,0,1-9.254,0Zm3.071,6.611.984,2.46-1.4,6.306A17.128,17.128,0,0,1,2.4,19.1,10.188,10.188,0,0,1,10.444,13.111ZM12,22h0Zm1.975-.123-1.4-6.305.985-2.461A10.188,10.188,0,0,1,21.6,19.1,17.128,17.128,0,0,1,13.973,21.877Z'
      data-name='64 Beim Kunden_Icon'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCustomer' };
</script>
